<template>
  <div class="opportunities-container">
    <loading-state v-if="loading" variant="opportunities" />
    <v-card v-else elevation="2" class="opportunities-card d-flex flex-column justify-start">
      <div class="header-title d-flex inline aling-center justify-center my-6">
        <img :src="require('@/assets/icons/mar.ia.svg')" class="mr-2" alt="maria" width="36" height="36" />
        <span>Oportunidades</span>
      </div>
      <div class="opportunities-content">
        <blur-card v-if="shouldBlurOpportunities" :blur-caption="blurOpportunitiesText" :blur-icon="blurOpportunitiesIcon" />
        <div class="px-5">
          <div class="description">
            <span>Identificamos </span>
            <span class="emphasis">{{ productsCount }} produtos</span>
            <span> com queda de vendas em </span>
            <span class="emphasis"> todas as lojas </span>
            <span> , comparando com mês anterior. </span>
          </div>
          <div class="drop-container my-6">
            <span>Quedas identificadas:</span>
            <mf-stonks variant="percentage" show-text percentage-text="Faturamento" :percentage="revenuePercentage"></mf-stonks>
            <mf-stonks variant="percentage" show-text :percentage-text="itemsClientsPercentage.text" :percentage="itemsClientsPercentage.number"></mf-stonks>
          </div>
          <div class="description mb-5">
            <span>Realizando ações propostas através da análise de dados, é possível recuperar:</span>
          </div>
          <div class="card-footer d-flex flex-row justify-space-between align-center">
            <div>
              <mf-stonks potential-text variant="potential"></mf-stonks>
              <div class="potential mt-2">
                <span>R$</span>
                <span class="potential-text ml-1">{{ potentialRevenue }}</span>
              </div>
            </div>
            <mf-button
              label="Ver detalhes"
              icon="arrow_forward"
              color="marca-0-l40"
              icon-position="right"
              :loading="buttonLoading"
              @click="refreshOpportunities"
            ></mf-button>
          </div>
          <div class="clip-ticket d-flex justify-space-between align-center">
            <div class="left"></div>
            <div class="line"></div>
            <div class="right"></div>
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import BlurCard from '@/components/BlurCard.vue'
import MfStonks from '../../../maria/produtos-impulsionadores/views/components/Step1/MfStonks.vue'
import LoadingState from './LoadingState.vue'
import { mapActions } from 'vuex'
import { localeString } from '@/config/helpers.js'

export default {
  name: 'OpportunitiesCard',
  components: {
    MfStonks,
    LoadingState,
    BlurCard,
  },
  props: {
    opportunities: {
      type: Object,
    },
    loader: {
      type: [String, Array],
    },
    booleanLoader: {
      type: Boolean,
      default: false,
    },
    haveAvailableOpportunities: {
      type: Boolean,
      default: false,
    },
    havePermission: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    buttonLoading: false,
  }),
  computed: {
    shouldBlurOpportunities() {
      return !this.haveAvailableOpportunities || !this.havePermission
    },
    blurOpportunitiesText() {
      if (!this.havePermission) {
        return 'Sem permissão de acesso'
      } else if (!this.haveAvailableOpportunities) {
        return 'Sem oportunidades detectadas'
      }
      return ''
    },
    blurOpportunitiesIcon() {
      if (!this.havePermission) {
        return 'lock'
      } else if (!this.haveAvailableOpportunities) {
        return 'lightbulb'
      }
      return ''
    },
    productsCount() {
      return this.opportunities?.products?.length
    },
    revenuePercentage() {
      return 0 - this.opportunities?.revenuePercentage * 100
    },
    itemsClientsPercentage() {
      let number = 0 - this.opportunities?.clientsPercentage * 100
      let text = 'Clientes'
      if (this.opportunities?.basketItemsPercentage > this.opportunities?.clientsPercentage) {
        number = 0 - this.opportunities?.basketItemsPercentage * 100
        text = 'Itens na cesta'
      }
      return { number, text }
    },
    potentialRevenue() {
      return localeString(this.opportunities.potentialRevenue)
    },
    loading() {
      if (this.booleanLoader) {
        return this.booleanLoader
      }
      if (this.loader) {
        if (Array.isArray(this.loader)) {
          return this.$wait.is(['primeiro-registro', 'last-update', 'get-last-update', ...this.loader])
        }
        return this.$wait.is(['primeiro-registro', 'last-update', 'get-last-update', this.loader])
      }
      return false
    },
  },
  methods: {
    ...mapActions(['getProductsBySKU']),
    async refreshOpportunities() {
      try {
        this.buttonLoading = true
        const products = await this.getProductsBySKU({ skus: this.opportunities.products })
        this.$router.push({
          name: 'produtosImpulsionares',
          params: {
            products,
          },
        })
      } catch (error) {
        console.error(error)
        this.$snackbar({ message: 'Erro ao buscar os produtos das oportunidades.', snackbarColor: 'error' })
        this.buttonLoading = false
      }
    },
  },
}
</script>

<style scoped lang="scss">
.opportunities-container {
  height: 100% !important;

  .opportunities-content {
    position: relative;
    height: 100%;
  }
  .opportunities-card {
    height: 100% !important;
    border-radius: 8px !important;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.16) !important;

    .header-title {
      span {
        color: $cinza-d10;
        font-size: 22px;
        font-weight: 700;
        letter-spacing: 0.22px;
      }
    }
    .description {
      color: $cinza-0;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      .emphasis {
        color: $marca-1;
        font-weight: 700;
      }
    }
    .drop-container {
      display: inline-flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;
      span {
        color: $cinza-d10;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
      }
    }
    .card-footer {
      position: absolute;
      bottom: 12px;
      width: 88%;
      .potential {
        span {
          color: $cinza-l60;
          font-size: 22px;
          font-weight: 700;
          line-height: 120%;
          letter-spacing: 0.22px;
        }
        .potential-text {
          color: $cinza-d20;
        }
      }
    }
  }
}
.clip-ticket {
  width: calc(100% + 20px);
  position: absolute;
  bottom: 20%;
  left: -10px;

  .line {
    width: 100%;
    height: 1px;
    background-image: repeating-linear-gradient(-34deg, $cinza-l50, $cinza-l50 7px, transparent 7px, transparent 17px, $cinza-l50 17px),
      repeating-linear-gradient(56deg, $cinza-l50, $cinza-l50 7px, transparent 7px, transparent 17px, $cinza-l50 17px),
      repeating-linear-gradient(146deg, $cinza-l50, $cinza-l50 7px, transparent 7px, transparent 17px, $cinza-l50 17px),
      repeating-linear-gradient(236deg, $cinza-l50, $cinza-l50 7px, transparent 7px, transparent 17px, $cinza-l50 17px);
    background-size: 2px 100%, 100% 2px, 2px 100%, 100% 2px;
    background-position: 0 0, 0 0, 100% 0, 0 100%;
    background-repeat: no-repeat;
  }
  .right {
    width: 20px;
    height: 20px;
    background-color: #f6f6f8;
    border-radius: 50%;
    box-shadow: inset 1px 0px 0px #aaaaaa;
  }

  .left {
    width: 20px;
    height: 20px;
    background-color: #f6f6f8;
    border-radius: 50%;
    box-shadow: inset -1px 0px 0px rgba(0, 0, 0, 0.16);
  }
}
::v-deep .v-badge {
  display: flex;
  align-items: center;
}
::v-deep .v-btn {
  line-height: 120%;
  height: 48px !important;
  letter-spacing: normal;
  padding: 12px !important;
  border-radius: 8px;
  font-weight: 700;
}
::v-deep .v-skeleton-loader__avatar {
  background-color: $cinza-l80 !important;
}
::v-deep .v-skeleton-loader__text {
  height: 20px;
  background-color: $cinza-l80 !important;
}

@media screen and (max-width: 1420px) {
  ::v-deep .value.potential-text {
    font-size: 12px;
  }
  .potential {
    span {
      font-size: 20px !important;
    }
  }
  ::v-deep .v-btn {
    line-height: 100%;
    height: 48px !important;
    letter-spacing: normal;
    padding: 8px !important;
    border-radius: 8px;
    font-weight: 700;
  }
}
</style>
